<template>
  <div>
    <checklist-shared-navbar :SharedFillGuid="SharedFillGuid" />
    <shared-fill :SharedFillGuid="SharedFillGuid"></shared-fill>
    <div class="fixed-footer">
      <div style="margin-top: 50px;">
        <span style="color: white;">Powered by </span>
        <a
          href="https://rmschecklist.com.br"
          target="_blank"
          style="color: #9cff19;"
          >RMS Group</a
        >
      </div>
      <div class="mt-2 d-flex justify-content-center">
        <a
          style="margin-right: 1%;"
          href="https://www.instagram.com/rmschecklist/"
          target="_blank"
        >
          <img
            height="30"
            width="30"
            src="/img/instagram-icon.svg"
            alt="https://www.instagram.com/rmschecklist/"
          />
        </a>
        <a
          style="margin-left: 1%;"
          href="https://wa.me/554791410444?text=Olá, fiz o teste do app RMS Checklist e gostaria de saber mais informações"
          target="_blank"
        >
          <img
            height="30"
            width="30"
            src="/img/whatsapp-icon.svg"
            alt="https://wa.me/554791410444"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import ChecklistSharedNavbar from "@/pagesRms/checklist/Layout/ChecklistSharedNavbar.vue";
export default {
  name: "ChecklistSharedFill",
  components: {
    SharedFill: () =>
      import("@/components_rms/checklist/shareForm/SharedFill.vue"),
    ChecklistSharedNavbar
  },
  props: {
    SharedFillGuid: String
  }
};
</script>
<style scoped>
.fixed-footer {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 1%;
}

.fixed-footer > div {
  margin-bottom: 5px;
}

.fixed-footer a {
  text-decoration: none;
}

.fixed-footer .d-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fixed-footer img {
  margin: 0 5px;
}
</style>
